module.exports = __webpack_public_path__ + "media/images/element/sport-117169e4f4a18c9e5f3068a88b841ba5.svg";